<template>
    <Header />
    <div :class="{ 'router-container': true, 'promo-container': isPromoPage }">
        <router-view :key="$route.path" />
    </div>

    <Footer v-if="showFooter" class="mt-5" />
    <MarketplaceRoomsModal v-if="$store.state.utils.isMarketplaceRoomsModalOpen" />
    <CookiesModal />
</template>

<script>
import Footer from '@/components/Footer/Footer.vue'
import Header from '@/components/Header/HeaderDesktop/Header.vue'
import MarketplaceRoomsModal from '@/components/Components/MarketplaceRoomsModal/MarketplaceRoomsModal.vue'
import NotificationModal from '@/components/Modal/NotificationModal'
import LoginModal from '@/components/Modal/LoginModal'
import CookiesModal from '@/components/Components/CookiesModal/CookiesModal.vue'

export default {
    name: 'App',
    components: { CookiesModal, LoginModal, NotificationModal, Header, Footer, MarketplaceRoomsModal },

    data() {
        return {
            showFooter: true,
            resizeListener: null,
        }
    },

    computed: {
        isPromoPage() {
            return this.$store.state.utils.showPromoBackground
        },
    },

    watch: {
        $route() {
            this.showFooter = true
            if (this.$route?.meta?.hasOwnProperty('showFooter')) {
                this.showFooter = this.$route.meta.showFooter === true
            }

            this.$store.dispatch(
                'utils/togglePromoBackground',
                this.$route.name === 'MarketplaceProductPromoCategories',
            )
        },
    },

    async created() {
        // main.js already resolves language + loads i18n before mount.
        // Keep this if you still need it (it’s separate from initAuth).
        await this.$store.dispatch('user/loadAuthenticatedUser')
    },
}
</script>

<style lang="scss">
@use "@/assets/css/variables.scss" as *;

html {
    height: 100%;
    width: 100%;
    -webkit-overflow-scrolling: touch;
}

body {
    height: 100%;
    width: 100%;
    overflow: auto;
    padding: 0;
    margin: 0;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    font-family: $font-regular;
}

#app {
    font-family: $font-regular;
    color: #2c3e50;
}

.mt-6 {
    margin-top: 4rem !important;
}

.mt-7 {
    margin-top: 5rem !important;
}

.pt-7 {
    padding-top: 5rem !important;
}

.svg-icon {
    width: 2em;
    height: 2em;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
    fill: #4c4d4f;
}

.svg-icon circle {
    stroke: #4c4d4f;
    stroke-width: 1;
}

.border-bottom {
    border-bottom: 1px solid #ccc;
}

/* ✅ Vite-friendly promo background + nested rules */
.promo-container {
    padding-top: 30px;
    background: #81090d url("@/assets/images/promo-wrapper-background.png") top no-repeat;
    background-size: 100% auto;

    #marketplace-category-container {
        .marketplace-sort-filter-container {
            .sort-by {
                color: #ffffff;
            }
        }

        .pagination,
        .promo-filter-label,
        .grid-title,
        .filter-title,
        .filter-option-text,
        .icon-close-svg,
        .icon-arrow-down {
            color: #ffffff;
        }

        .filter-container-mobile {
            background: #81090d url("@/assets/images/promo-wrapper-background.png") top no-repeat !important;
            background-size: 100% auto !important;
        }
    }
}
</style>